import React from "react";
import PropTypes from "prop-types";
import { ListItemButton, ListItemText, ListItemIcon, Collapse } from "@mui/material";
import ExpandLess from "@mui/icons-material/ExpandLess";
import ExpandMore from "@mui/icons-material/ExpandMore";
import Star from "@mui/icons-material/Star";

const CollapsibleList = ({ onClick, icon, heading, children, expanded }) => {
  return (
    <div>
      <ListItemButton onClick={onClick}>
        <ListItemIcon>{icon}</ListItemIcon>
        <ListItemText primary={heading} />
        {expanded ? <ExpandLess /> : <ExpandMore />}
      </ListItemButton>
      <Collapse in={expanded} timeout="auto" unmountOnExit>
        {children}
      </Collapse>
    </div>
  );
};

CollapsibleList.defaultProps = {
  heading: "",
  icon: <Star />,
};

CollapsibleList.propTypes = {
  heading: PropTypes.string,
  icon: PropTypes.node,
  children: PropTypes.node,
  expanded: PropTypes.bool.isRequired,
  onClick: PropTypes.func.isRequired,
};

export default CollapsibleList;